var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 8,
    viewBox: "0 0 98 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333333 4C0.333333 5.47276 1.52724 6.66667 3 6.66667C4.47276 6.66667 5.66667 5.47276 5.66667 4C5.66667 2.52724 4.47276 1.33333 3 1.33333C1.52724 1.33333 0.333333 2.52724 0.333333 4ZM97.3536 4.35356C97.5488 4.1583 97.5488 3.84172 97.3536 3.64645L94.1716 0.464474C93.9763 0.269212 93.6597 0.269212 93.4645 0.464474C93.2692 0.659736 93.2692 0.976319 93.4645 1.17158L96.2929 4.00001L93.4645 6.82843C93.2692 7.0237 93.2692 7.34028 93.4645 7.53554C93.6597 7.7308 93.9763 7.7308 94.1716 7.53554L97.3536 4.35356ZM3 4.5L97 4.50001L97 3.50001L3 3.5L3 4.5Z",
    fill: "#3CBD96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1d3344dfb7a23626fc66d9dde5711501.svg";
export { ForwardRef as ReactComponent };